import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_PROJECT,
  GET_PROJECTS,
  ADD_PROJECT,
  UPDATE_PROJECT,
  DELETE_PROJECT
} from '@/queries/modules/common-data/project';

export async function getProjects(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_PROJECTS,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setProjects', data.getProjects);
      context.commit('setSuccess', null);
      return data.getProjects
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getProject(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_PROJECT,
        variables: payload
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setProject', data.getProject);
      context.commit('setSuccess', null);
      return data.getProject
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addProject(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_PROJECT,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const projects = [...context.state.projects];
      projects.push(data.addProject);
      context.commit('setProjects', projects);
      context.commit('setSuccess', newItemSuccess(data.addProject.nameLocal));

      return data.addProject
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateProject(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_PROJECT,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.projects.findIndex(item => item.id === data.updateProject.id);
      const projects = [
        ...context.state.projects.slice(0, index),
        data.updateProject,
        ...context.state.projects.slice(index + 1)
      ];
      context.commit('setProjects', projects);
      context.commit('setSuccess', updateItemSuccess(data.updateProject.nameLocal));

      return data.updateProject
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteProject(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_PROJECT,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.projects.findIndex(item => item.id === data.deleteProject.id);
      const projects = [
        ...context.state.projects.slice(0, index),
        ...context.state.projects.slice(index + 1)
      ];
      context.commit('setProjects', projects);
      context.commit('setSuccess', deleteItemSuccess(data.deleteProject.nameLocal));

      return data.deleteProject
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

